var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ressource-error-container"
  }, [_c('v-card', {
    staticClass: "ressource-error-card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', {
    staticClass: "text-center pa-8 pa-md-12"
  }, [_c('div', {
    staticClass: "error-illustration mb-8"
  }, [_c('svg', {
    attrs: {
      "width": "200",
      "height": "200",
      "viewBox": "0 0 200 200",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "80",
      "fill": "#FEE",
      "stroke": "#F44336",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M70 70L130 130M130 70L70 130",
      "stroke": "#F44336",
      "stroke-width": "8",
      "stroke-linecap": "round"
    }
  })])]), _c('h1', {
    staticClass: "text-h4 font-weight-bold mb-4 error-title"
  }, [_vm._v(" " + _vm._s(_vm.$translate("errorTitle")) + " ")]), _c('p', {
    staticClass: "text-body-1 mb-4 grey--text text--darken-1"
  }, [_vm._v(" " + _vm._s(_vm.$translate("errorLoadingResourceMessage")) + " ")]), _vm.error && _vm.error.message ? _c('v-alert', {
    staticClass: "mt-6 mb-6",
    attrs: {
      "type": "error",
      "outlined": "",
      "text": ""
    }
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('div', {
    staticClass: "font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.$translate("technicalDetails")) + ":")]), _c('div', {
    staticClass: "text-caption"
  }, [_vm._v(_vm._s(_vm.error.message))]), _vm.error.code ? _c('div', {
    staticClass: "text-caption mt-1"
  }, [_vm._v(" " + _vm._s(_vm.$translate("errorCode")) + ": " + _vm._s(_vm.error.code) + " ")]) : _vm._e()])]) : _vm._e(), _c('p', {
    staticClass: "text-body-2 mb-2 grey--text"
  }, [_vm._v(" " + _vm._s(_vm.$translate("contactAdministratorMessage")) + " ")]), _c('div', {
    staticClass: "mb-8"
  }, [_c('p', {
    staticClass: "text-body-2 mb-2 d-flex align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-email")]), _c('a', {
    staticClass: "support-link",
    attrs: {
      "href": "mailto:support@safetee.io"
    }
  }, [_vm._v("support@safetee.io")])], 1), _c('p', {
    staticClass: "text-body-2 mb-0 d-flex align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-phone")]), _c('a', {
    staticClass: "support-link",
    attrs: {
      "href": "tel:+33972195305"
    }
  }, [_vm._v("+33 9 72 19 53 05")])], 1)]), _c('div', {
    staticClass: "d-block d-sm-flex justify-center flex-wrap ga-4"
  }, [_c('v-btn', {
    staticClass: "w-100 w-sm-auto",
    attrs: {
      "color": "grey",
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" " + _vm._s(_vm.$translate('back')) + " ")], 1), _c('v-btn', {
    staticClass: "mt-4 mt-sm-0 ml-sm-6 w-100 w-sm-auto",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'dashboard'
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-home")]), _vm._v(" " + _vm._s(_vm.$translate('goToHome')) + " ")], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }